import BaseModel from './BaseModel';

class WalletModel extends BaseModel {
  public result: WalletInterface;

  constructor(arg: any) {
    super(arg);
    this.result = arg.result;
  }
}

export interface WalletInterface {
  id: string;
  store_id: string;
  store_name: string;
  store_url: string;
  store_address: {
    line1: string;
    line2: string;
    line3: string;
    city: string;
    state: string;
    zip_code: string;
  };
  phone_number: string;
  email: string;
  is_enabled: boolean;
  is_verified: boolean;
  bank_account_number: string;
  bank_bic: string;
  virtual_bank_account_number: string;
  balance: number;
  credits: number;
  authorized_amount: number;
  authorized_credits: number;
  overdraft_limit: number;
  currency: string;
  alert_low_balance: boolean;
  low_balance_threshold: number;
  business_info: {
    corporate_name: string;
    vat_number: string;
    address: string;
    national_id: string;
    commercial_registration_number: string;
    national_id_photo: string;
    account_type: string;
    commercial_registration_photo: string;
  };
  verification_status: number;
  verification_rejection_reason: string;
  manager_phone_number: string;
  created_at: string;
  updated_at: string;
  bank_account_holder_name: string;
  is_zidpay_splitting_enabled: boolean;
  total_balance: number;
}

export default WalletModel;
